<template>
  <div class="flow-service-table" v-loading="loading">
    <div class="summary-cards">
      <div v-for="card in cardList" :key="card.title" class="summary-card"
        :class="{ 'date-range-card': card.isDateRange }">
        <div v-if="card.isDateRange" class="date-range-value">
          <div class="date-item">
            <div class="date-text">{{ card.startDate }}</div>
            <div class="time-text">{{ card.startTime }}</div>
          </div>
          <div class="arrow">→</div>
          <div class="date-item">
            <div class="date-text">{{ card.endDate }}</div>
            <div class="time-text">{{ card.endTime }}</div>
          </div>
        </div>
        <div v-else class="card-value">{{ card.value }}</div>
        <div class="card-title">{{ card.title }}</div>
      </div>
    </div>
    <el-table :data="tableData" border stripe style="width: 100%">
      <el-table-column prop="payWalletListId" label="支付流水号" width="280" />
      <el-table-column prop="payAmount" label="流量费价格（元）" width="120" />
      <el-table-column prop="activeStartDatetime" label="服务开始时间" width="200" />
      <el-table-column prop="expiryDatetime" label="服务到期时间" width="200" />
      <el-table-column prop="recordStatus" label="服务周期状态" width="200" />
      <el-table-column prop="payType" label="支付方式" width="100">
        <template slot-scope="scope">
          {{ getPayTypeText(scope.row.payType) }}
        </template>
      </el-table-column>
      <el-table-column prop="payDatetime" label="支付完成时间" width="200" />
      <el-table-column prop="createdWhen" label="账单创建时间" width="200" />
    </el-table>
    <el-pagination v-if="total > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 16px; text-align: right" />
  </div>
</template>

<script>
export default {
  name: "FlowServiceTable",
  props: {
    activityOrderId: { type: String, default: '' },
    activityOrderNo: { type: String, default: '' },
  },
  data() {
    return {
      flowInfo: {},
      tableData: [],
      loading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
    };
  },
  computed: {
    cardList() {
      const info = this.flowInfo || {};
      let dateRangeCard = { title: "当前服务周期", value: "暂无", isDateRange: false };
      if (info.startTime && info.endTime) {
        const [startDate, startTime] = info.startTime.split(" ");
        const [endDate, endTime] = info.endTime.split(" ");
        dateRangeCard = { title: "当前服务周期", isDateRange: true, startDate: startDate || "", startTime: startTime || "", endDate: endDate || "", endTime: endTime || "" };
      }
      return [
        { title: "累计使用月份", value: info.monthsOfUse || 0 },
        { title: "累计支付金额", value: `${info.accumulatedPayments || 0}元` },
        { title: "流量周期费用", value: `${info.chargingStandards || 0}元` },
        { title: "当前服务状态", value: this.getServiceStatusText(info.recordStatus) },
        dateRangeCard,
        { title: "当前服务剩余天数", value: info.daysRemaining ? `${info.daysRemaining}天` : "0天" },
      ];
    },
  },
  watch: {
    activityOrderId: {
      handler(newVal) {
        if (newVal) { this.fetchFlowServiceInfo(); this.fetchTableData(); }
      },
      immediate: true,
    },
    activityOrderNo: {
      handler(newVal) {
        if (newVal) this.fetchTableData();
      },
    },
  },
  methods: {
    fetchFlowServiceInfo() {
      if (!this.activityOrderId && !this.activityOrderNo) return;
      this.loading = true;
      const params = { activityOrderNo: this.activityOrderNo || this.activityOrderId };
      this.$H.post(this, this.$A.activityOrder.axbTrafficStatistics, params).then((res) => {
        if (res.data && res.data.status === 200) {
          this.flowInfo = res.data.data || {};
        } else {
          this.$message.error(res.data?.message || "获取流量服务信息失败");
        }
      }).catch(() => {
        this.$message.error("获取流量服务信息失败");
      }).finally(() => {
        this.loading = false;
      });
    },
    fetchTableData() {
      if (!this.activityOrderId && !this.activityOrderNo) return;
      this.loading = true;
      const params = {
        activityOrderNo: this.activityOrderNo || this.activityOrderId,
        pageNum: this.pageNum - 1,
        pageSize: this.pageSize,
      };
      this.$H.post(this, this.$A.activityOrder.trafficStatisticsPage, params).then((res) => {
        if (res.data && res.data.status === 200) {
          const data = res.data.data || {};
          this.tableData = data.content || data.list || data.records || [];
          this.total = data.totalElements || data.total || 0;
        } else {
          this.$message.error(res.data?.message || "获取表格数据失败");
        }
      }).catch(() => {
        this.$message.error("获取表格数据失败");
      }).finally(() => {
        this.loading = false;
      });
    },
    handleSizeChange(val) { this.pageSize = val; this.pageNum = 1; this.fetchTableData(); },
    handleCurrentChange(val) { this.pageNum = val; this.fetchTableData(); },
    getServiceStatusText(status) {
      const statusMap = { TO_EXPRIRED: "即将到期", EXPIRED: "已过期", TO_ACTIVE: "待激活", ACTIVE: "正常", IN_ACTIVE: "正常", EXPIRING_SOON: "即将到期", CANCELLED: "已解约（买断）", IN_EXPIRED: "已解约(到期)" };
      return statusMap[status] || status || "未知";
    },
    getPayTypeText(payType) {
      const payTypeMap = { ALIPAY: "支付宝", MANTUAL_ALIPAY: "支付宝", SYSTEM_GIFT: "系统赠送", CYCLE_WITH_HOLD: "自动扣款" };
      return payTypeMap[payType] || payType || "--";
    },
  },
};
</script>

<style scoped>
.flow-service-table {
  margin-top: 10px;
}

.summary-cards {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.summary-card {
  flex: 1;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.card-value {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 6px;
  white-space: nowrap;
}

.card-title {
  font-size: 16px;
  color: #6b7280;
}

.date-range-card {
  min-width: 280px;
}

.date-range-value {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 6px;
}

.date-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.date-text {
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
  white-space: nowrap;
}

.time-text {
  font-size: 13px;
  color: #6b7280;
  white-space: nowrap;
}

.arrow {
  font-size: 24px;
  color: #9ca3af;
  font-weight: bold;
  margin: 0 8px;
}
</style>
